/** The documents page, out of /admin: every signed-in user browses it, only deleting needs the role. */
export const DOCUMENTS_ROUTE = "/documents";

/** Where the documents page first lived: links already shared keep working. */
export const FORMER_DOCUMENTS_ROUTE = "/admin/vectorstore";
